<template>
  <div style="text-align:center; margin-top: 16px;">
    <div id="video-container" :key="new Date()"></div>
  </div>
  <div style="margin-top: 16px; text-align: center;">
    <h-button type="danger" @click="closeThisPage">
      返回
    </h-button>
  </div>
</template>

<script>
import EZUIKit from 'ezuikit-js'
import h_i18n from '@/utils/Internationalization';

var player = null
export default {
  name: 'ToFactoryMonitor',
  data() {
    return {
      url: this.$route.query.url,
      accessToken: this.$route.query.accessToken,
      supplyCode: this.$route.query.supplyCode,
    }
  },
  methods: {
    h_i18n,
    // 截图
    tackPic() {
      var capturePicturePromise = player.capturePicture(`${new Date().getTime()}`);
      capturePicturePromise.then((data) => {
        console.log("promise 获取 数据", data)
      })
    },
    initOfLive() {
      if (!this.accessToken || !this.url) {
        this.$alert(h_i18n('5BEC9D3537B83DF8778E27248478FE5B'), '失败', {
          confirmButtonText: '确定',
          type: 'error',
          callback() {
            window.close()
          }
        })
        return
      }
      player = new EZUIKit.EZUIKitPlayer({
        id: 'video-container', // 视频容器ID
        url: this.url,
        accessToken: this.accessToken,
        width: 1000,
        height: 600,
        audio: 0,
        // template:"pcLive",
        handleSuccess: () => {

        },
        handleError: () => {
          
        }
      })
    },
    //关闭
    closeThisPage() {
      if(player){
        player.stop()
      }
      window.close()
    },
  },
  created() {
  },
  mounted() {
    this.initOfLive()
  },
  beforeUnmount() {

  }
}
</script>

<style src="@/assets/css/new.scss" lang="scss"></style>
<style scoped>
.addressStyle {
  /* width: 440px; */
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.factoryStyle {
  /* width: 280px; */
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* .factorySearchStyle > .haier-search--slot{
  min-height: 34px;
  height: auto;
} */
/* .addressStyle:hover {
  width: 440px;
  word-break: break-all;
  overflow: auto;
  white-space: normal;
  text-overflow: clip;
} */

/* .factoryStyle:hover {
  width: 280px;
  word-break: break-all;
  overflow: auto;
  white-space: normal;
  text-overflow: clip;
} */
/* .addressSearchStyle > .haier-search--slot{
  min-height: 34px;
  height: auto;
} */
</style>
<style scoped lang="scss">
:deep(.error_button_style) {
  background-color: #D9001B;
  color: #fff !important;
  border-radius: 4px;
  border: 0;

  .haier-button-content {
    background-color: #D9001B;
    border-radius: 4px;
    border: 0;

    .haier-loading-text {
      color: #fff !important;
    }
  }

  .error_button_style:hover {
    background-color: #e67481;
    border: 0;
    border-radius: 4px;
  }

  .haier-button-content:hover {
    border: 0;
    background-color: #e67481;
    border-radius: 4px;
  }
}

:deep(.haier-search--null) {
  height: auto;
  min-height: 36px;
  background-color: #FAFAFA;
}
</style>
<style>
.is-E5969E6{
  line-height: 18px !important;
  font-size:12px !important;
  padding: 6px 12px;
  background: linear-gradient(90deg, #4E5969E6, #4E5969E6);
  color: #fff;
}

.is-E5969E6 .el-popper__arrow::before {
  background: linear-gradient(45deg, #4E5969E6, #4E5969E6);
  right: 0;
}
</style>